import { ThemeTokens } from './themeTokens';

const SET_THEME_TOKENS = 'SET_THEME_TOKENS';

export interface UiThemeState {
  themeTokens: ThemeTokens;
}

const defaultState: UiThemeState = {
  themeTokens: {},
};

interface SetThemeTokensAction {
  type: typeof SET_THEME_TOKENS;
  payload: { themeTokens: ThemeTokens };
}

type UiThemeActions = SetThemeTokensAction;

function uiThemeReducer(
  state = defaultState,
  action: UiThemeActions,
): UiThemeState {
  switch (action.type) {
    case SET_THEME_TOKENS:
      return {
        ...state,
        themeTokens: action.payload.themeTokens,
      };
    default:
      return state;
  }
}

export default uiThemeReducer;

export const setThemeTokens = (themeTokens: ThemeTokens): SetThemeTokensAction => ({
  type: SET_THEME_TOKENS,
  payload: { themeTokens },
});
